export const LangOptions = [
  "GERMAN",
  "ENGLISH",
  "MONGOLIAN",
  "ROMANIAN",
  "GEORGIAN",
  "PORTUGUESE",
  "VIETNAMESE",
  "BASQUE",
  "MALTESE",
  "JAPANESE",
  "NORWEGIAN",
  "BULGARIAN",
  "CZECH",
  "ITALIAN",
  "FRENCH",
  "NEPALI",
  "SLOVENIAN",
  "CROATIAN",
  "SLOVAK",
  "SPANISH",
  "HUNGARIAN",
  "UZBEK",
  "KHMER",
  "LITHUANIAN",
  "HINDI",
  "SERBIAN",
  "BELARUSIAN",
  "SINHALA",
  "DANISH",
  "FINNISH",
  "ICELANDIC",
  "PERSIAN",
  "ESTONIAN",
  "BENGALI",
  "BURMESE",
  "MALAY",
  "GREEK",
  "THAI",
  "HEBREW",
  "DUTCH",
  "MACEDONIAN",
  "KAZAKH",
  "RUSSIAN",
  "TURKISH",
  "ARMENIAN",
  "ARABIC",
  "LATVIAN",
  "CHINESE",
  "ALBANIAN",
  "AZERBAIJANI",
  "BOSNIAN",
  "KOREAN",
  "SWEDISH",
  "POLISH",
]

export const DefaultFormValue = {
  start_date_time: null,
  end_date_time: null,
  description: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  short_description: {
    en: '',
    de: '',
    it: '',
    nl: ''
  },
  stage_id: null,
  fair_id: '',
  user_id: null,
  languages: [
    {
      label: 'GERMAN',
      value: 'GERMAN'
    }
  ],
  first_name: '',
  last_name: '',
  portrait: {
    url: '',
    raw: '',
    filename: ''
  },
}